const statuses = {
    0: 'Pending',
    1: 'Uploaded',
    2: 'Error',
    3: 'No transfer'
};

export { statuses as default };
